import { useEffect } from "react";

function useAddTargetBlankToLinks(className) {
    useEffect(() => {
        const container = document.querySelector(`.${className}`);
        if (!container) return;

        const links = container.querySelectorAll("a[href^='http']");
        console.log("...", links);
        links.forEach(link => {
            if (link.hostname !== window.location.hostname) {
                link.setAttribute("target", "_blank");
                link.setAttribute("rel", "noopener noreferrer");
            }
        });
    }, [className]);
}

export default useAddTargetBlankToLinks;
